<template>
  <div>
    <swipe v-if="floor.$row === 'row-swipe'" :floor="floor" :home="home" @call="onCall" />
    <special v-else-if="floor.$row === 'row-special'" :floor="floor" :home="home" @call="onCall" />
    <images v-else :floor="floor" :home="home" @call="onCall"/>
  </div>
</template>

<script>
import Images from './images'
import Swipe from './swipe'
import Special from './special'
export default {
  components: { Images, Swipe,Special },
  props: {
    floor: Object,
    home: Object
  },
  methods: {
    onCall(e) {
      this.$emit('call', e)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
